import { InjectionToken } from '@angular/core';

export interface IIPLookupService {
  getIp(): Promise<string>;
}

export const IIPLookupServiceToken = new InjectionToken<IIPLookupService>('IIPLookupService');
